/**
 * 主应用 frame 与 `s-app-window` 弹窗 iframe 之间同步 SaveBar 状态的桥接。
 *
 * 背景：customizeBackdrop / customizeShowcase 在嵌入环境下走 `ThemeLayoutAppWindowHost`，
 * 编辑内容渲染在 `<s-app-window>` 的内嵌 iframe 里。iframe 内 App Bridge 派发的
 * ContextualSaveBar 不会冒到 Admin 顶部；弹窗内也没有"全局保存"位置。
 *
 * 因此需要：iframe 把 SaveBar 状态广播给主应用 frame，由主应用 frame 在其自己的
 * App Bridge 上派发 ContextualSaveBar（Admin 顶部全局保存条），用户点击后再反向
 * 广播 save/discard 动作让 iframe 执行真正的业务回调。
 *
 * 主应用 frame 与弹窗 iframe 同源（均加载自应用域），可使用 BroadcastChannel。
 */

export const APP_WINDOW_SAVE_BAR_CHANNEL = "pp-app-window-save-bar"

export interface AppWindowSaveBarState {
  show: boolean
  loading: boolean
  disabled: boolean
  unlocking: boolean
}

export type AppWindowSaveBarAction = "save" | "discard"

export type AppWindowSaveBarMessage =
  | { type: "state", payload: AppWindowSaveBarState }
  | { type: "action", payload: AppWindowSaveBarAction }
  | { type: "request-state" }
  | { type: "child-unmount" }

export const createAppWindowSaveBarChannel = (): BroadcastChannel | null => {
  if (typeof window === "undefined" || typeof BroadcastChannel === "undefined") {
    return null
  }

  return new BroadcastChannel(APP_WINDOW_SAVE_BAR_CHANNEL)
}

export const isAppWindowSaveBarMessage = (data: unknown): data is AppWindowSaveBarMessage => {
  if (!data || typeof data !== "object") {
    return false
  }
  const message = data as { type?: unknown }

  return (
    message.type === "state"
    || message.type === "action"
    || message.type === "request-state"
    || message.type === "child-unmount"
  )
}
